import { render, staticRenderFns } from "./holes-add-par.vue?vue&type=template&id=c2df53d2&scoped=true"
import script from "./holes-add-par.vue?vue&type=script&lang=js"
export * from "./holes-add-par.vue?vue&type=script&lang=js"
import style0 from "./holes-add-par.vue?vue&type=style&index=0&id=c2df53d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2df53d2",
  null
  
)

export default component.exports